import React from "react";
import { motion } from "framer-motion";
import "../pages/About.css";
import aboutImg from "../assets/aboutus.jpg"; // replace with your image path
import OurStory from "./OurStoryAboutUs";
import bannerImg from "../assets/bannerImg.jpg"; // replace with your image path
import aboutCollection from "../assets/aboutCollection.jpg"; // replace with your image path

export default function AboutUs() {
  // Parent container animation
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3, // delay between children
      },
    },
  };

  // Each child animation
  const fadeSlideUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <>
    <section className="about-section">
      {/* Heading */}
      <motion.h2
        className="about-title"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        About Us
      </motion.h2>

      {/* Banner Image */}
      <motion.div
        className="about-img-wrapper"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <img src={aboutImg} alt="About Us" className="about-img" />
      </motion.div>

      {/* Content */}
      <motion.div
        className="about-content"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
        viewport={{ once: true, amount: 0.3 }}
      >
      </motion.div>
    </section>
     <section className="design-section">
     <motion.div
       className="design-wrapper"
       variants={container}
       initial="hidden"
       whileInView="show"
       viewport={{ once: true, amount: 0.3 }}
     >
       {/* Heading */}
       <motion.h2 className="design-title" variants={fadeSlideUp}>
         Design Studio
       </motion.h2>

       {/* Content */}
       <div className="design-content">
         {/* Left */}
         <motion.p
           className="design-text"
           variants={fadeSlideUp}
           whileHover={{ scale: 1.02 }}
         >
           <strong>At Maya Exports Pvt Ltd.</strong>, creativity meets craftsmanship.
           We specialize in creating stylish, functional spaces that bring fashion
           to life. Our team blends modern design with classic aesthetics to reflect
           your brand’s identity—whether you’re launching a boutique or refreshing a
           retail space.
         </motion.p>

         {/* Right */}
         <motion.p
           className="design-text"
           variants={fadeSlideUp}
           whileHover={{ scale: 1.02 }}
         >
           From layout planning to visual merchandising, we focus on every detail
           that enhances customer experience and maximizes product visibility. Let
           us transform your clothing store into a destination where style meets
           story.
         </motion.p>
       </div>
     </motion.div>
   </section>

   <OurStory/>

   <section className="banner">
      <motion.img
        src={bannerImg}
        alt="Clothing Banner"
        className="banner__image"
        initial={{ opacity: 0, scale: 1.1 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1.2, ease: "easeOut" }}
        whileHover={{ scale: 1.05, filter: "brightness(1.1)" }}
      />
    </section>
    <section className="new-collection">
      <motion.div
        className="collection-image"
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <img
          src={aboutCollection}
          alt="Clothing Collection"
        />
      </motion.div>

      <motion.div
        className="collection-content"
        initial={{ opacity: 0, x: 80 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <p className="offer-text">SAVE UP TO 70%</p>
        <h2 className="collection-title">New Collection</h2>
        <p className="collection-description">
          Step into the season with our stunning New Collection — where trend
          meets tradition. Featuring fresh designs, vibrant colors, and refined
          craftsmanship for every occasion.
        </p>
        <p className="collection-description">
          Elevate your wardrobe with pieces that define elegance and
          individuality.
        </p>

      
      </motion.div>
    </section>
   </>
  );
}
